module.exports = __webpack_public_path__ + "media/images/mobile/home/type1-f31e189c2b8d8002fc35363ec227e3fe.png";